const awsConfiguration = {
    region: 'ap-northeast-1',
    IdentityPoolId: 'ap-northeast-1:db9eaea4-4000-4d7d-8971-ff2528ac6d97',
    UserPoolId: 'ap-northeast-1_hQr8tODU0',
    ClientId: '3adpi9ivkbjh5f82cqnssd3roc',
}

export default awsConfiguration
